module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, window) {
	'use strict';

	fox.registerWidget('Control_Input', {

		configure: function (options) {

			this.registerOptions('', {
				container: '.input-container',
				template: 'control_input',
				autoRender: true,
				containerClassesList: '',
				templateOptions: {
					name: 'input_name',
					size: 'size-medium',
					icon: 'with-icon',
					clear: 'with-clear',
					placeholder: 'Type something'
				},
				handleDom: {
					clear: {
						target: '.clear',
						event: 'click',
						callback: 'clear'
					},
					submit: {
						target: 'form',
						event: 'submit',
						callback: function (el, alias, w, e) {
							fox.dom.event.stop(e);
							this.submit();

							return false;
						}.bind(this)
					},
					iconClick: {
						target: '.form-submit',
						event: 'click',
						callback: 'submit'
					},
					input: {
						target: 'input[name]',
						event: 'input',
						callback: '_handleInputChange'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.submitDelay = this.getOption('submitDelay') || null;

			this.callParent('running', arguments);
		},

		getValue: function () {
			return this.getInputElement().value;
		},

		setValue: function (val) {
			this._setValue(val);

			if (val && val.length) {
				this.toggleClearIcon(true);

				return;
			}

			this.toggleClearIcon(false);
		},

		_setValue: function(val) {
			this.getInputElement().value = val;
		},

		getInputElement: function () {
			return this.dom1('input[name]');
		},

		clear: function () {
			this.setValue('');
			this.dispatchEvent('clear');
			this.submit();
		},

		_handleInputChange: function (el) {
			var val = this.getValue();

			if (this.submitDelay) {
				
				if (this.delayTimeout) {
					window.clearInterval(this.delayTimeout);
					this.delayTimeout = null;
				}

				this.delayTimeout = window.setTimeout(function () {
					this.submit();
				}.bind(this), this.submitDelay);
			}

			if (val.length) {
				this.toggleClearIcon(true);

				return;
			}

			this.toggleClearIcon(false);
		},

		toggleClearIcon: function (state) {
			fox.dom[state ? 'addClass' : 'removeClass']('not-empty', this.getInputElement());
		},

		submit: function () {
			if (this.delayTimeout) {
				window.clearInterval(this.delayTimeout);
				this.delayTimeout = null;
			}

			this.dispatchEvent('submit', {value: this.getValue()});
		}

	}, 'Widget');

})(fox, window);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/input.js
// module id = 301
// module chunks = 2